import React from 'react'
import {ImageCircle} from 'components'

export const SchedulePageSummary = ({schedule, style, ...props}) => {
  const src = schedule.chatterUserAccount && schedule.chatterUserAccount.userDetails.profilePicture;
  const name = schedule.remotePage ?
    schedule.remotePage.name :
    schedule.chatterUserAccount ?
      schedule.chatterUserAccount.remoteAccountName :
      '';

  return <div style={{...style, margin: '10px 0'}} {...props}>
    <ImageCircle size={30} src={src} style={{verticalAlign: 'middle'}}/>
    <span style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: '10px'}}>{name}</span>
  </div>
}
